import { isAcademicStaffCourse } from "@/utils/funcionarios";
import { isAlumnosCourse, isCpaCourse } from "@/utils/parseCourseCode";
export const APP_SECTIONS = [
    "treasury",
    "messaging",
    "activities",
    "me",
];
const usesAcademicHome = (curso) => isAlumnosCourse(curso) ||
    isAcademicStaffCourse(curso);
const COURSE_ACTIVITIES_TAB = {
    section: "activities",
    labelKey: "nav.activities",
    icon: "bi bi-kanban",
    rootRouteName: "activities-hub",
};
const CPA_ACTIVITIES_TAB = {
    section: "activities",
    labelKey: "nav.cpaHome",
    icon: "bi bi-speedometer2",
    rootRouteName: "menu-cpa",
};
export const BOTTOM_NAV_TABS = [
    {
        section: "treasury",
        labelKey: "nav.treasury",
        icon: "bi bi-house",
        rootRouteName: "main-view",
    },
    {
        section: "messaging",
        labelKey: "nav.messaging",
        icon: "bi bi-chat-dots",
        rootRouteName: "messaging-conversations",
    },
    COURSE_ACTIVITIES_TAB,
    {
        section: "me",
        labelKey: "nav.me",
        icon: "bi bi-person",
        rootRouteName: "me-hub",
    },
];
/** Tabs del bottom nav según el grupo activo (CPA remapea el slot Grupo → Inicio CPA). */
const ACADEMIC_HOME_TAB = {
    section: "treasury",
    labelKey: "nav.treasury",
    icon: "bi bi-house",
    rootRouteName: "asignaciones-home",
};
export const getBottomNavTabs = (curso) => {
    const activitiesTab = isCpaCourse(curso)
        ? CPA_ACTIVITIES_TAB
        : COURSE_ACTIVITIES_TAB;
    return BOTTOM_NAV_TABS.map((tab) => {
        if (tab.section === "activities")
            return activitiesTab;
        if (tab.section === "treasury" && usesAcademicHome(curso))
            return ACADEMIC_HOME_TAB;
        return { ...tab };
    });
};
export const APP_SECTION_ROOT = {
    treasury: "main-view",
    messaging: "messaging-conversations",
    activities: "activities-hub",
    me: "me-hub",
};
/** Prefijos de path → sección (fallback si la ruta no declara meta.appSection). */
const PATH_SECTION_PREFIXES = [
    { prefix: "/user/mensajeria", section: "messaging" },
    { prefix: "/user/activities", section: "activities" },
    { prefix: "/user/menu-cpa", section: "activities" },
    { prefix: "/user/cpa", section: "activities" },
    { prefix: "/user/inspector", section: "activities" },
    { prefix: "/user/me", section: "me" },
    { prefix: "/user/clasificados", section: "activities" },
    { prefix: "/user/transporte", section: "activities" },
    { prefix: "/user/tareas", section: "activities" },
    { prefix: "/user/kiosco", section: "activities" },
    { prefix: "/user/kioscos", section: "activities" },
    { prefix: "/user/kiosk", section: "activities" },
    { prefix: "/user/ventas", section: "activities" },
    { prefix: "/user/donaciones", section: "activities" },
    { prefix: "/user/asignaciones", section: "activities" },
    { prefix: "/user/mis-retiros", section: "treasury" },
    { prefix: "/user/retiros", section: "treasury" },
    { prefix: "/user/main-view", section: "treasury" },
    { prefix: "/user/mis-pagos", section: "treasury" },
    { prefix: "/user/mis-deudas", section: "treasury" },
    { prefix: "/user/mis-comprobantes", section: "treasury" },
    { prefix: "/user/registrar-abono", section: "treasury" },
    { prefix: "/user/registrar-abonos", section: "treasury" },
    { prefix: "/user/abonar-cobros", section: "treasury" },
    { prefix: "/user/gestion-centro-costos", section: "treasury" },
    { prefix: "/user/detalle-fondo", section: "treasury" },
    { prefix: "/user/registrar-gasto", section: "treasury" },
    { prefix: "/user/registrar-ingreso", section: "treasury" },
    { prefix: "/user/ver-ingresos", section: "treasury" },
    { prefix: "/user/ver-gastos", section: "treasury" },
    { prefix: "/user/ver-pagos", section: "treasury" },
    { prefix: "/user/validar-pagos", section: "treasury" },
    { prefix: "/user/ver-usuarios-grupo", section: "messaging" },
    { prefix: "/user/ver-usuarios", section: "treasury" },
    { prefix: "/user/comisiones", section: "activities" },
    { prefix: "/user/asignaciones", section: "activities" },
    { prefix: "/user/email-masivo", section: "activities" },
    { prefix: "/user/notificaciones-email", section: "activities" },
    { prefix: "/user/gestion-ventas", section: "activities" },
    { prefix: "/user/gestion-donaciones", section: "activities" },
    { prefix: "/user/modificar-directiva", section: "activities" },
    { prefix: "/user/crear-link-asociacion", section: "activities" },
    { prefix: "/user/crear-curso", section: "activities" },
    { prefix: "/user/ver-directivas", section: "activities" },
];
const ROUTE_NAME_SECTION = {
    "main-view": "treasury",
    "mis-pagos": "treasury",
    "mis-deudas": "treasury",
    "mis-comprobantes": "treasury",
    "registrar-abono-centro-costo": "treasury",
    "registrar-abonos-por-cc": "treasury",
    "abonar-cobros-cuotas": "treasury",
    "abonar-cobros-v2": "treasury",
    "gestion-centro-costos": "treasury",
    "detalle-fondo": "treasury",
    "registrar-gasto": "treasury",
    "registrar-ingreso": "treasury",
    "ver-ingresos": "treasury",
    "ver-gastos": "treasury",
    "ver-pagos-generales": "treasury",
    "ver-pagos-usuario": "treasury",
    "validar-pagos": "treasury",
    "messaging-conversations": "messaging",
    "messaging-conversation": "messaging",
    "messaging-unavailable": "messaging",
    "activities-hub": "activities",
    "menu-cpa": "activities",
    "clasificados-home": "activities",
    "clasificados-list": "activities",
    "clasificados-nuevo": "activities",
    "clasificados-mis-avisos": "activities",
    "clasificados-mis-interacciones": "activities",
    "clasificados-detalle": "activities",
    "clasificados-moderacion": "activities",
    "transporte": "activities",
    "transporte-viaje": "activities",
    "transporte-rutas": "activities",
    "transporte-solicitudes": "activities",
    "transporte-buscar": "activities",
    "transporte-mis": "activities",
    "transporte-mapa": "activities",
    "tareas-mis": "activities",
    "tareas-grupo": "activities",
    "tareas-nueva": "activities",
    "tareas-detalle": "activities",
    "kioscos-list": "activities",
    "ventas-list": "activities",
    "donaciones-list": "activities",
    "gestion-ventas": "activities",
    "gestion-donaciones": "activities",
    "comisiones-list": "activities",
    "encuestas-list": "activities",
    "asignaciones-home": "activities",
    "asignaciones-proceso": "activities",
    "asignaciones-preferencias": "activities",
    "email-masivo": "activities",
    "email-masivo-cpa": "activities",
    "notificaciones-email-list": "activities",
    "mis-retiros": "treasury",
    "me-hub": "me",
    "ver-usuarios-grupo": "messaging",
    "ver-usuarios": "treasury",
    "modificar-directiva": "activities",
    "crear-link-asociacion-curso": "activities",
    "crear-link-asociacion-directivas": "activities",
    "cpa-gestionar-cursos": "activities",
    "cpa-crear-cursos": "activities",
    "cpa-funcionarios": "activities",
    "cpa-kiosk-users": "activities",
    "cpa-validacion-ingreso": "activities",
    "validar-ingreso": "activities",
    "inspector-apoderados": "activities",
    "inspector-apoderado-detalle": "activities",
    "inspector-qr-logs": "activities",
    "ver-directivas": "activities",
    "crear-curso": "activities",
    "crear-curso-institucion": "activities",
};
export const isAppSection = (value) => typeof value === "string" &&
    APP_SECTIONS.includes(value);
export const resolveAppSection = (route) => {
    const metaSection = route.meta?.appSection;
    if (isAppSection(metaSection))
        return metaSection;
    const name = typeof route.name === "string" ? route.name : "";
    if (name && ROUTE_NAME_SECTION[name])
        return ROUTE_NAME_SECTION[name];
    const path = route.path || "";
    for (const entry of PATH_SECTION_PREFIXES) {
        if (path === entry.prefix || path.startsWith(`${entry.prefix}/`)) {
            return entry.section;
        }
    }
    return null;
};
export const rootRouteNameForSection = (section, curso) => {
    if (section === "activities" && isCpaCourse(curso)) {
        return "menu-cpa";
    }
    if (section === "treasury" && usesAcademicHome(curso)) {
        return "asignaciones-home";
    }
    return APP_SECTION_ROOT[section];
};
